export const getBaseUrlForRedirect = (): string => {
  const {
    location: { origin, port },
  } = window;

  if (port) {
    const [protocol, host] = origin.split(':');

    return `${protocol}:${host}`;
  } else {
    return origin;
  }
};
